import { Navigate } from "react-router-dom";
import { useRole, type TawaRole } from "./useRole";
import { HOME_PATH } from "../nav";

interface Props {
  roles: TawaRole[];
  children: React.ReactNode;
}

export function RoleRoute({ roles, children }: Props) {
  const role = useRole();
  if (role === null || !roles.includes(role)) {
    return <Navigate to={HOME_PATH} replace />;
  }
  return <>{children}</>;
}
